import { useState } from 'react'
import AccordionItem from '@/Components/accordian'
import Image from 'next/image'
import Link from 'next/link'

// Exported so pages that render this section (the Integra-AI product page) can emit
// FAQPage schema from the same copy.
export const faqs = [
  {
    id: 1,
    header: 'What services do your AI professionals provide?',
    text:
      'Our AI professionals offer tailored solutions, including AI strategy development, machine learning model creation, natural language processing applications and data science services, to meet your business needs.',
  },
  {
    id: 2,
    header: 'How can AI consulting benefit my business?',
    text:
      'AI consulting can improve efficiency by automating tasks, provide data-driven insights for informed decision-making and improve customer experiences through personalized interactions.',
  },
  {
    id: 3,
    header: 'What industries do you serve with your AI consulting services?',
    text:
      'We cater to various industries, including healthcare, retail, insurance, financial services, real estate, manufacturing and e-commerce, customizing AI solutions to each sector\'s unique challenges and goals.',
  },
  {
    id: 4,
    header: 'How do I start integrating AI into my business with your help?',
    text:
      'Begin by contacting us for a consultation. We\'ll assess your business needs, develop a tailored AI strategy and guide you through the implementation process to ensure seamless integration.',
  },
  {
    id: 5,
    header: 'What is the difference between AI, machine learning and data science?',
    text:
      'AI encompasses the broader concept of machines exhibiting intelligence. Machine learning, a subset of AI, focuses on systems learning from data. Data science involves extracting insights from data using various techniques, including AI and machine learning.',
  },
];


const FAQs = () => {
  const [active, setActive] = useState(null)

  const handleToggle = (index) => {
    setActive(active === index ? null : index)
  }

  return (
    <section className="relative bg-white w-full py-10 px-3 lg:py-20 lg:px-20">
      
      {/* Decorative FAQ Image */}
      <div className="absolute top-0 left-10 h-[100px] w-[270px] -translate-x-1/2 md:left-64 md:translate-x-0">
        <Image
          src="/travel-b2b/FAQ.png"
          alt="AI consultation frequently asked questions illustration"
          fill
          style={{ objectFit: "contain" }}
          priority
        />
      </div>

      <h2 className="mb-10 text-center text-[36px] font-bold text-[#172554]">
        FAQ's
      </h2>

      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col gap-6">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              active={active}
              handleToggle={handleToggle}
              faq={faq}
            />
          ))}
        </div>
      </div>

      <div className="flex flex-col items-center justify-center gap-4 pt-20 text-center">
        <h1 className="text-xl font-semibold">
          Still Have Questions?
        </h1>

        <Link
          href="/contact"
          className="rounded-full border border-blue-700 bg-blue-700 px-5 py-2 text-sm text-white transition hover:bg-blue-500 sm:px-6 sm:text-base"
        >
          Contact Support
        </Link>
      </div>

    </section>
  )
}

export default FAQs